import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { addDeviceToRoomUrl } from "./api-url.constants";

export interface AddDeviceToRoomParams {
  roomId: string;
  monitorId: string;
  location: string;
  licenses: Array<{
    serviceContractId: string;
    licenseId: string;
    productId: string;
    family: string;
    monitorId: string;
  }>;
}

export const addDeviceToRoom = async ({
  roomId,
  monitorId,
  location,
  licenses,
}: AddDeviceToRoomParams): Promise<void> => {
  const response = await typedFetch(addDeviceToRoomUrl(roomId), {
    method: API_METHODS.POST,
    body: JSON.stringify({ monitorId, location, licenses }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || "Error adding device to room");
  }
};
